import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AudioPlayer from '../components/AudioPlayer';
import LastEvents from '../components/LastEvents';
import traks from '../data/traks';
import OnPageLoaded from '../utils/onpageloaded';
import $ from 'jquery';

//import WOW from 'wowjs';
require("../css/pagehome.css");

class Home extends Component {
    componentDidMount() {
        document.title = "Damatrà: musica e balli folk in Lombardia";
        const description = "Il gruppo di musica popolare Damatrà propone un ampio repertorio di danze folk dei Paesi europei. Attivo a Milano, in Brianza e in tutto il Nord Italia.";
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        OnPageLoaded(true, true);
    }

    scrollTo = (param) => (e) => {
        const xposition = $(param).offset().top - 60;
        $('html, body').animate({ scrollTop: xposition }, 1000);
    }

    render() {
        return (
            <div className="container">
                <div className="dotted-scrollspy rounded-left">
                    <ul className="nav smooth-scroll clearfix d-none d-sm-flex flex-column">
                        <li className="nav-item"><a className="nav-link" title="Intro" onClick={this.scrollTo("#fullpageheader")} ><span></span></a></li>
                        <li className="nav-item"><a className="nav-link" title="Chi siamo" onClick={this.scrollTo("#about")}  ><span></span></a></li>
                        <li className="nav-item"><a className="nav-link" title="Prossimi concerti e Brani demo" onClick={this.scrollTo("#nextconcerts")} ><span></span></a></li>
                    </ul>
                </div>
                <section id="about" className="section">
                    <div className="divider-new mt-5">
                        <h2 className="h2-responsive mx-4 wow fadeIn acmefont">
                            Chi siamo
                            <i className="fas fa-users descicon"></i>
                        </h2>
                    </div>
                    <div className="row mt-5">
                        <div className="col-lg-6 col-md-12 mb-4 wow fadeIn" data-wow-delay=".4s">
                            <picture>
                                <source type="image/webp" srcset="/img/home/damatra-gruppo.webp" />
                                <img style={{ width: "100%" }} src="/img/home/damatra-gruppo.jpg" loading="lazy" className="img-fluid z-depth-1" alt="Gruppo folk Damatrà" />
                            </picture>
                        </div>
                        <div className="col-lg-6 col-md-12 wow fadeIn mr-auto text-size" data-wow-delay=".4s">
                            <p align="justify" className="grey-text-3">Il termine <strong>Damatrà</strong> significa <i>dammi retta</i> in dialetto Brianzolo, ma esprime anche un gioco di parole: <i>Dama delle Tradizioni</i>.</p>
                            <p align="justify" className="grey-text-3">Il gruppo, nato nel 2005, propone un vastissimo repertorio di <strong>danze popolari</strong> provenienti da tutta l'<strong>Europa</strong>, come ad esempio <i>circolo circassiano</i>, <i>chapelloise</i>, <i>pizzica</i>, <i>valzer</i>, <i>mazurke</i>, <i>an dro</i>, <i>bourrée</i>, <i>polka</i>, <i>scottish</i>, ecc., rivisitate con contaminazioni di sonorità moderne.</p>
                            <p align="justify" className="grey-text-3">Oltre alle <strong>musiche folk tradizionali</strong>, il repertorio è arricchito da <strong>composizioni proprie</strong>, cucite sempre sugli schemi dei balli popolari.</p>
                            <p align="justify" className="grey-text-3">Melodie e ritmi tradizionali s'incontrano quindi con influenze più moderne, per dare vita a una musica piena di energia ma sempre al servizio della danza.</p>
                            <p align="justify" className="grey-text-3">Il gruppo è formato da volti ormai ben noti nel mondo del folk europeo e ha al suo attivo numerosi concerti in diverse feste, locali e festival principalmente in Lombardia e in tutto il Nord Italia.</p>
                            <p align="justify" className="grey-text-3">Contattaci per concerti pubblici, sagre, matrimoni, feste private e serate a tema. Siamo attivi a <strong>Milano</strong>, in <strong>Brianza</strong> e in tutto il Nord Italia.</p>
                            <p className="text-center"><a href="/contatti" className="btn primary-bkg" rel="nofollow">Contattaci</a></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 mt-5 mb-2 wow fadeIn" data-wow-delay=".4s">
                            <section id="nextconcerts" className="section">
                                <div className="divider-new mt-5">
                                    <h2 className="h2-responsive mx-4 wow fadeIn acmefont">
                                        Prossimi concerti
                                        <i className="far fa-calendar-alt fa-fw descicon"></i>
                                    </h2>
                                </div>
                                <LastEvents></LastEvents>
                                <div className="text-center mt-4">
                                    <Link className="btn primary-bkg" to="/concerti">Visualizza tutti i concerti</Link>
                                </div>
                            </section>
                        </div>
                        <div className="col-lg-6 col-md-12 mt-5 mb-2 wow fadeIn" data-wow-delay=".4s">
                            <section id="musicplayer" className="section">
                                <div className="divider-new mt-5">
                                    <h2 className="h2-responsive mx-4 wow fadeIn acmefont">
                                        Brani demo
                                        <i className="fas fa-headphones fa-fw descicon"></i>
                                    </h2>
                                </div>
                                <div>
                                    <AudioPlayer trakslist={traks}></AudioPlayer>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js